import { Topbar } from './Topbar'
import { WelcomeVideo } from '@/components/molecules/Admin/Modals/OnboardingStudent/WelcomeVideo'
import { Calendar } from '@/components/molecules/Admin/Modals/OnboardingStudent/Calendar'
import { Whatsapp } from '@/components/molecules/Admin/Modals/Whatsapp'
import Notification from '@/components/molecules/Admin/Notification'
import DrawerCourse from '@/components/molecules/Admin/DrawerCourse'
import { GoogleCalendar } from '@/components/molecules/Admin/Modals/GoogleCalendar'
import { useUpdateGoogleCalendar } from '@/utils/hooks/useUpdateGoogleCalendar'
import { useShowWhatsappModal } from '@/utils/hooks/useShowWhatsappModal'
import { FeedbackClass } from '@/components/molecules/Admin/Modals/FeedbackClass'
import { useShowModals } from '@/utils/hooks/useShowModals'
import { SkillMapping } from '@/components/molecules/Admin/Modals/SkillMapping'

interface AdminProps {
	children: React.ReactNode
}

export function AdminLayout({ children }: AdminProps) {
	useUpdateGoogleCalendar()

	useShowWhatsappModal()
	useShowModals()

	return (
		<div className='w-full flex flex-col justify-center items-center overflow-clip bg-zinc-950'>
			<Topbar />
			<div className='flex flex-col w-full min-h-[_calc(100vh_-_98px)] overflow-clip relative'>
				{children}
			</div>

			<DrawerCourse />
			<Notification />

			{/* start of student onboarding */}
			<WelcomeVideo disabledOnClose />
			<Calendar disabledOnClose />
			{/* end of student onboarding */}

			<Whatsapp disabledOnClose />
			<GoogleCalendar disabledOnClose />
			<FeedbackClass disabledOnClose />

			<SkillMapping />
		</div>
	)
}
